// extracted by mini-css-extract-plugin
export default {"container":"RatingSlider_container__GKJkr","title":"RatingSlider_title__go2vR","labels":"RatingSlider_labels__BlC0a","label":"RatingSlider_label__HtV9f"};